const shareMeIndex = resolve => {
  import(/* webpackChunkName: 'homeIndex' */'../views/share/index').then(shareMeIndex => {
    resolve(shareMeIndex)
  })
}

export default [{
  path: '/wechat/shareMe',
  name: 'share_me',
  component: shareMeIndex,
  meta: {
    title: '分享个人中心',
    requireAuth: false,
    keepAlive: false,
    footer: false
  }
}]
